import React, { ComponentPropsWithoutRef, ReactElement } from 'react';
import classnames from 'classnames';

export type CheckboxProps = ComponentPropsWithoutRef<'input'> & {
  label?: string;
  testId?: string;
};

export function Checkbox({
  disabled,
  label,
  id,
  checked,
  ...rest
}: CheckboxProps): ReactElement {
  const classes = classnames('checkbox', {
    disabled,
  });

  return (
    <label className={classes} htmlFor={id}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        id={id}
        {...rest}
      />
      <span className="checkbox__input" aria-checked={checked}></span>
      {label && <span className="checkbox__label">{label}</span>}
    </label>
  );
}
